var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingCart = function SvgShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 3.667H6.012l-.364-1.859A1 1 0 0 0 4.667 1H.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h3.343l2.9 14.82a2.667 2.667 0 1 0 4.233.512h6.048a2.667 2.667 0 1 0 4.156-.59l.043-.196a1 1 0 0 0-.977-1.213H8.49l-.391-2h13.017a1 1 0 0 0 .977-.787l1.884-8.667A1 1 0 0 0 23 3.667m-14.333 17a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m10.666 0a1.001 1.001 0 0 1 0-2 1.001 1.001 0 0 1 0 2m.977-8.334H7.708L6.403 5.667h15.356z"
  }))));
};
export default SvgShoppingCart;